export default "__VITE_ASSET__ZXoi3qre__"